/**
 * The "Taking you to our events site" transition (spec §5.1 Transition, K-10). Shown when a gate link is
 * clicked anywhere on the page (the hero, the sections, the site's footer), for at most ~0.5 s, before the
 * browser navigates to the gate. Skipped under prefers-reduced-motion and for modified clicks (new tab).
 * Links stay plain <a> elements; nothing here prefetches or mints tokens. The gate itself never serves a page.
 */
import { useEffect, useState } from "react";
import { isGateHref } from "../lib/gate";

export const DELAY_MS = 450;

export function GateTransition() {
  const [leaving, setLeaving] = useState(false);
  useEffect(() => {
    const onClick = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target?.closest?.("a[href]");
      if (!a || a.target === "_blank" || a.hasAttribute("download")) return;
      if (!isGateHref(a.getAttribute("href") || "")) return;
      if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
      e.preventDefault();
      setLeaving(true);
      setTimeout(() => { window.location.href = a.href; }, DELAY_MS);
    };
    document.addEventListener("click", onClick);
    const onShow = (e) => { if (e.persisted) setLeaving(false); }; // back button from bfcache
    window.addEventListener("pageshow", onShow);
    return () => { document.removeEventListener("click", onClick); window.removeEventListener("pageshow", onShow); };
  }, []);
  if (!leaving) return null;
  return (
    <div className="ev-leaving" role="status" aria-live="polite">
      <img src="/events-assets/logo-wordmark-white.png" alt="" width="640" height="96" />
      <span className="ev-leaving-text">Taking you to our events site</span>
      <span className="ev-spin" aria-hidden="true" />
    </div>
  );
}
